module.exports = __webpack_public_path__ + "static/img/logo_joinUS.c2300a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/JoinUS/logo_joinUS.png
// module id = 5fWG
// module chunks = 7